import { createOtherIncidentHttpRepository } from '@src/main/modules/other_incidents/infrastructure/OtherIncidentHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

type UpdateIncidentAnsweredParams = {
  id: string;
  idAnswered: string;
  fullNameAnswered: string;
  dateAnswered: string;
};

export const updateIncidentAnsweredUseCase = async (
  { id, idAnswered, fullNameAnswered, dateAnswered }: UpdateIncidentAnsweredParams,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createOtherIncidentHttpRepository(tokenProvider);

  await repository.updateIncident({
    id,
    idAnswered,
    fullNameAnswered,
    dateAnswered,
  });
};
